import React from 'react'

const LogoLogin = () => {
  return (
    <div>
      <svg width="300" height="46" viewBox="0 0 386 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.0273438 46V3.89476H9.9553V46H0.0273438Z" fill="black" />
        <path d="M28.6412 45.9965V11.4983H34.499L64.1657 34.4033V11.4983H71.8564V45.9965H65.9646L36.3867 22.7316V45.9965H28.6412Z" fill="black" />
        <path d="M87.4617 45.9965V11.4983H124.545V17.6727H96.0555V26.675H111.39V33.09H96.0555V45.9965H87.4617Z" fill="black" />
        <path d="M121.572 45.9945L142.314 11.4963H150.505L171.569 45.9945H162.006L157.608 38.4267H134.486L130.088 45.9945H121.572ZM138.117 32.131H154.137L145.987 17.749L138.117 32.131Z" fill="black" />
        <path d="M180.288 45.9965V11.4983H186.146L215.813 34.4033V11.4983H223.519V45.9965H217.629L188.049 22.7316V45.9965H180.288Z" fill="black" />
        <path d="M239.118 45.9945V11.4963H247.593V45.9945H239.118Z" fill="black" />
        <path d="M264.626 10.836C264.626 6.65752 265.451 3.80661 267.101 2.28322C268.752 0.759829 271.964 -0.00124206 276.738 1.52152e-06H312.786C317.593 1.52152e-06 320.812 0.761073 322.442 2.28322C324.072 3.80536 324.891 6.65628 324.899 10.836V35.1082C324.899 39.324 324.064 42.1929 322.395 43.7151C320.725 45.2372 317.525 45.9977 312.792 45.9964H276.744C271.972 45.9964 268.76 45.236 267.107 43.7151C265.454 42.1942 264.629 39.3252 264.632 35.1082L264.626 10.836ZM275.977 37.1806H313.533V8.45388H275.977V37.1806Z" fill="#0099FF" />
        <path d="M341.939 45.9965V11.4983H347.797L377.464 34.4033V11.4983H385.172V45.9965H379.259L349.681 22.7316V45.9965H341.939Z" fill="black" />
      </svg>


    </div>
  )
}

export default LogoLogin

